import DashboardDefault from "./index"
const DashboardPage=()=>{
    return(
        <DashboardDefault />
    )
}
export default DashboardPage;